// extracted by mini-css-extract-plugin
module.exports = {"modal":"index-modal-1CRxh","close":"index-close-3o33n","iframe":"index-iframe-uozGa","videoBox":"index-videoBox-1sRfj","videoContainer":"index-videoContainer-6NbcI"};